import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16395b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "upload-picture-component" }
const _hoisted_2 = { class: "file-input" }
const _hoisted_3 = { for: "file" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Tirar foto ")
const _hoisted_6 = { class: "image-upload-viewer" }
const _hoisted_7 = { class: "image-viewer" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tirar uma nova foto", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "file",
        id: "file",
        class: "file",
        accept: "image/*",
        capture: "camera",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pictureChanged && _ctx.pictureChanged(...args)))
      }, null, 32),
      _createElementVNode("label", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.cameraIconPath,
          class: "camera-icon"
        }, null, 8, _hoisted_4),
        _hoisted_5
      ])
    ], 512), [
      [_vShow, _ctx.imagePath == null]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", { src: _ctx.imagePath }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("div", {
        class: "return",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.takePictureAgain && _ctx.takePictureAgain(...args)))
      }, _hoisted_10)
    ], 512), [
      [_vShow, _ctx.imagePath != null]
    ])
  ]))
}